import { __rest } from "tslib";
import React, { lazy, Suspense, useState } from 'react';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import ErrorBoundary from '../../ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
import MediaManager from '../../MediaPopup/MediaManager';
import Flex from '@wix/da-ds/pkg/Flex';
import { MediaSourceType } from '../../MediaPopup';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '../../types/deviation';
var LoadableInit = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "tiercreator" */
        '../redux/creator/ModuleLoadable');
    });
});
var TierManageContentButton = function (_a) {
    var _b, _c;
    var type = _a.type, tierDeviation = _a.tierDeviation, profileOwner = _a.profileOwner, className = _a.className, props = __rest(_a, ["type", "tierDeviation", "profileOwner", "className"]);
    var t = useTranslation().t;
    var _d = useState(false), showMM = _d[0], setShowMM = _d[1];
    var tierItemsCount = ((_c = (_b = tierDeviation === null || tierDeviation === void 0 ? void 0 : tierDeviation.tier) === null || _b === void 0 ? void 0 : _b.stats) === null || _c === void 0 ? void 0 : _c[type]) || 0;
    var onManagementDone = function () {
        setShowMM(false);
        props.pushLoadingModal();
        // Pressing ESC key to close the MM cancels the reload.
        // Let's postpone it by 1 cycle
        setTimeout(function () {
            window.location.href = Url.userSubscriptionsPath({
                username: profileOwner.username,
                tierDeviationId: tierDeviation.deviationId,
                tierContentType: type,
            });
        }, 1);
    };
    return (React.createElement(ErrorBoundary, { debugComponent: "TierManageContentButton" },
        React.createElement(Flex, { className: className },
            React.createElement(GhostButton, { size: 'medium', variant: 'main', onClick: function () { return setShowMM(true); }, biData: {
                    evid: BiEventType.TIER_ADD_CONTENT,
                    typeid: DeviationResourceType.TIER,
                    itemid: tierDeviation.deviationId,
                    button_name: type,
                } }, type === 'deviations'
                ? t(tierItemsCount > 0
                    ? 'deviation.tier.editContent.deviations'
                    : 'deviation.tier.addContent.deviations')
                : t(tierItemsCount > 0
                    ? 'deviation.tier.editContent.posts'
                    : 'deviation.tier.addContent.posts')),
            showMM && (React.createElement(Suspense, { fallback: null },
                React.createElement(LoadableInit, null),
                React.createElement(MediaManager, { title: t(type === 'deviations'
                        ? 'mediapopup.tierManager.deviations'
                        : 'mediapopup.tierManager.posts'), allowUploads: false, tier: tierDeviation, withAddDeviationsPopupOpen: tierItemsCount === 0, onClose: onManagementDone, onDone: onManagementDone, initialMediaSource: type === 'deviations'
                        ? MediaSourceType.TIER_DEVIATIONS
                        : MediaSourceType.TIER_POSTS }))))));
};
TierManageContentButton.displayName = 'TierManageContentButton';
export default TierManageContentButton;
//# sourceMappingURL=TierManageContentButton.js.map